import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLoginAdminMutation } from "../../features/api/appApi";
import { AdminButton, AdminField, AdminInput, AdminStatusBadge } from "./AdminSectionCard";

const AdminLogin = () => {
  const { isAuthenticated } = useSelector((state) => state.adminAuth);
  const [loginAdmin, { isLoading, error }] = useLoginAdminMutation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (isAuthenticated) {
    return <Navigate to="/admin/overview" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    await loginAdmin({ email, password });
  };

  return (
    <main className="min-h-screen overflow-x-hidden bg-gradient-to-br from-slate-100 via-blue-50 to-indigo-100 px-4 py-10 sm:py-16">
      <div className="mx-auto w-full max-w-md">
        <div className="overflow-hidden rounded-3xl border border-slate-200/90 bg-white p-5 shadow-[0_16px_34px_-20px_rgba(15,23,42,0.35)] sm:p-7">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Admin Panel</p>
          <h1 className="mt-2 text-2xl font-black tracking-tight text-slate-900 sm:text-3xl">Admin Login</h1>
          <p className="mt-1 text-sm text-slate-500">Use admin email and password.</p>

          <form onSubmit={onSubmit} className="mt-6 space-y-3">
            <AdminField label="Email">
              <AdminInput
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </AdminField>

            <AdminField label="Password">
              <AdminInput
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </AdminField>

            {error ? (
              <AdminStatusBadge tone="red">{error?.data?.message || "Login failed"}</AdminStatusBadge>
            ) : null}

            <AdminButton className="w-full" type="submit" disabled={isLoading}>
              {isLoading ? "Signing in..." : "Sign in"}
            </AdminButton>
          </form>
        </div>
      </div>
    </main>
  );
};

export default AdminLogin;
